import { render, staticRenderFns } from "./BloquearClienteModal.vue?vue&type=template&id=35bab4ca&scoped=true"
import script from "./BloquearClienteModal.vue?vue&type=script&lang=js"
export * from "./BloquearClienteModal.vue?vue&type=script&lang=js"
import style0 from "./cashbackModal.css?vue&type=style&index=0&id=35bab4ca&prod&scoped=true&lang=css&external"
import style1 from "./cashbackModalCaixa.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bab4ca",
  null
  
)

export default component.exports